import React from 'react';
import PropTypes from 'prop-types';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { withRouter } from 'react-router';
import { getPath } from '~/utils/routes';
import AgentScannersViewContainer from './components/AgentScannersView/AgentScannersView.container';
import ScanConfigurationsListContainer from './components/ScanConfigurationsList/ScanConfigurationsList.container';

const AgentScannersList = ({ route, match }) => {
  const history = useHistory();
  const routeMatch = useRouteMatch();

  // Extract scannerId from route params
  const scannerId = match?.params?.scannerId;

  // Enhance route object with scannerId from params
  const enhancedRoute = {
    ...route,
    scannerId
  };

  const handleScanConfigurationClick = (scanConfig, options = {}) => {
    if (options.action === 'update') {
      return;
    }

    const basePath = routeMatch.url.endsWith('/')
      ? routeMatch.url
      : `${routeMatch.url}/`;
    const targetPath = `${basePath}${scanConfig.id}/`;

    history.push(targetPath);
  };

  const handleEditScanner = (scannerIdParam) => {
    const editPath = getPath('agentScannersEdit', {
      scannerId: scannerIdParam
    });

    history.push(editPath);
  };

  // Navigate back to scanner list (called after form submit/cancel)
  const handleFormClose = () => {
    const basePath = routeMatch.url
      .replace(/\/add\/?$/, '/')
      .replace(/\/[^/]+\/edit\/?$/, '/');

    history.push(basePath);
  };

  return (
    <AgentScannersViewContainer
      route={enhancedRoute}
      onScanConfigurationClick={handleScanConfigurationClick}
      onEditScanner={handleEditScanner}
      onFormClose={handleFormClose}
      getPath={() => ''}
      ScanConfigurationsListComponent={ScanConfigurationsListContainer}
    />
  );
};

AgentScannersList.propTypes = {
  route: PropTypes.shape({
    isAdd: PropTypes.bool,
    isEdit: PropTypes.bool
  }),
  match: PropTypes.shape({
    params: PropTypes.shape({
      scannerId: PropTypes.string
    }),
    url: PropTypes.string
  })
};

export default withRouter(AgentScannersList);
